<script setup>
import {computed, ref, nextTick} from 'vue'
import {useFormStore} from '@/stores/form'
import FormControlTypeSelect from './FormControlTypeSelect'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    currentData: Object,
    field: Object,
    options: [String, Array, Object],
})

// Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Template refs and reactive data
const input = ref(null)
const btn = ref(null)
const otherOption = ref(props.field.other || 'Other…')
const other = ref(false)
const storedValue = ref(undefined)

// Computed properties
const formSmall = computed(() => {
    return formStore.value?.formSmall
})

// Methods
const showOther = () => {
    other.value = true

    storedValue.value = props.currentData[props.field.name]
    props.currentData[props.field.name] = ''

    nextTick(() => {
        if (input.value) {
            input.value.select()
        }
    })
}

const hideOther = () => {
    other.value = false

    props.currentData[props.field.name] = storedValue.value

    nextTick(() => {
        if (btn.value) {
            btn.value.focus()
        }
    })
}
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <div v-else class="input-group">
        <!-- v-if is used to remove element from the DOM, otherwise validation will fail -->
        <FormControlTypeSelect v-if="!other" :current-data="currentData" :field="field" :form-id="formId"
                               :options="options"/>

        <template v-if="otherOption">
            <button v-if="!other" ref="btn" class="btn btn-outline-secondary btn-sm" type="button" @click="showOther">
                {{ otherOption }}
            </button>

            <template v-else>
                <input ref="input" v-model="currentData[field.name]" class="form-control" type="text"
                       @keyup.esc="hideOther" :class="{'form-control-sm': formSmall}">

                <button class="btn btn-outline-secondary" :class="{'btn-sm': formSmall}" type="button"
                        @click="hideOther">
                    <i class="bi-x-lg"/>
                </button>
            </template>
        </template>
    </div>
</template>